/*eslint-disable */
import articleListEventObserver from './articleList';

export default class PaginationEventHandler {

    /**
     * Constructor
     * @param {*} el
     */
    constructor(el, options) {
        this.el = el;
        this.options = options;        
        this.paginationEls = this.options.pagination ? this.el.querySelectorAll(this.options.pagination) : null;
        this.bindEvents();
    }

    /**
     * Binds event handlers
     */
    bindEvents() {
        // bind pagination click event handler        
        if (this.paginationEls) {
            for (let i = 0, n = this.paginationEls.length; i < n; i++) {
                this.paginationEls[i].addEventListener('click', (evt) => {
                    const target = evt.target.tagName === 'A' ? evt.target : evt.target.parentNode.parentNode.parentNode;

                    if (target.tagName === 'A') {
                        evt.preventDefault();
                        articleListEventObserver.emit(articleListEventObserver.EVENTS.PAGINATION, {
                            url: target.href
                        });
                    }
                });
            }
        }
        // bind product list RESULT event
        articleListEventObserver.on(articleListEventObserver.EVENTS.RESULTS, (res) => this.update(res));
    }

    /**
     * Update html sections of controlbar
     * @returns undefined
     */
    update(res) {
        let content;
        const resultDOM = document.createElement('div');

        resultDOM.innerHTML = res[this.options.resultKey] || '';
        // update pagination sections
        if (this.paginationEls.length) {
            this.options.pagination.split(',').map((selector) => {
                content = resultDOM.querySelector(selector);
                if (content) {
                    this.el.querySelector(selector).innerHTML = content.innerHTML;
                }
            });            
        }
    }
}


// WEBPACK FOOTER //
// /src/pages/main/paginationEventHandler.js